import { FooterContainer } from './styles'

const Footer = () => {
    return (
        <FooterContainer>Desenvolvido por Bruno oliveira</FooterContainer>
    )
}

export default Footer